import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import Breadcrumb from "./breadcrumb";

// temporarily handle title setting as we did in RVC 15.0.0, in the future
// the collection of breadcrumbs should be used to pass in the correct data.
const channel = Radio.channel("global");

const DEFAULTS = {
  className: "flex",
  template: false,
  childView: Breadcrumb,
};

class Breadcrumbs extends Marionette.CollectionView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  initialize() {
    // temporary
    this.listenTo(channel, "set:title", this._onSetTitle);
  }

  // temporary
  _onSetTitle(model) {
    this.collection.reset({
      title: model.getTitle(),
      subtitle: model.getSubtitle(),
    });
  }
}

export { Breadcrumbs as default };
